import * as React from 'react';
import s from './Section.module.scss';
import Text from './Text';

type Props = {
  sectionName?: string;
  backgroundColor?: string;
  title?: string;
  wide?: boolean;
  slim?: boolean;
  slimTop?: boolean;
  slimBottom?: boolean;
  anchor?: string;
  wideMobile?: boolean;
  wideDesktop?: boolean;
  style?: any;
};

class Section extends React.Component<Props> {
  render() {
    const {
      sectionName,
      children,
      backgroundColor,
      title,
      wide,
      slim,
      slimTop,
      slimBottom,
      anchor,
      wideMobile,
      wideDesktop,
      style,
    } = this.props;

    const containerClass = wideMobile
      ? `container container-fluid-mobile`
      : wide
      ? 'container-fluid'
      : `container`;

    return (
      <section
        data-sectionname={sectionName}
        className={`${s.wrapper} ${slim ? s.slim : ''} ${
          slimTop ? s.slimTop : ''
        } ${slimBottom ? s.slimBottom : ''}`}
        style={{ backgroundColor, ...style }}
      >
        <div
          className={containerClass}
          id={anchor ? anchor.toLocaleLowerCase() : undefined}
        >
          {title && (
            <div className="row">
              <div className="col-md-6 offset-md-3">
                <Text h2 light border="narrow">
                  {title}
                </Text>
              </div>
            </div>
          )}
          <div className="row">
            <div className={`col-12 ${wideDesktop ? 'px-xl-0' : ''}`}>
              {children}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Section;
